import 'normalize.css';
import './index.scss';
import '@/initialize';

import ReactDOM        from 'react-dom/client';
import App             from '@/App';
import authStore       from '@widesk-core/stores/authStore';
import devToolbarStore from '@widesk-core/stores/devToolbarStore';
import * as Sentry     from '@sentry/react';
import { ReactNode }   from 'react';

// Les clés de session sont préfixées : en local, d'autres projets servis sur le même port y rangent leur propre `token`.
const SESSION_KEY_PREFIX = 'tokamap_';
authStore.setStorage({
	getItem: key => localStorage.getItem(SESSION_KEY_PREFIX + key),
	setItem: (key, value) => localStorage.setItem(SESSION_KEY_PREFIX + key, value),
	removeItem: key => localStorage.removeItem(SESSION_KEY_PREFIX + key),
});

Sentry.init({
	enabled: !__LOCAL__,
	dsn: "https://b0f173625eb9a38fecc0bb7105fbd506@o240489.ingest.us.sentry.io/4511376336617472",
	integrations: [
		new Sentry.BrowserTracing({
			tracePropagationTargets: ['localhost', /^https:\/\/.+tokamap/],
		}),
		new Sentry.Replay(),
	],
	tracesSampleRate: 1.0,
	replaysSessionSampleRate: 0.1,
	replaysOnErrorSampleRate: 1.0,
});

if (__LOCAL__) {
	const _error = console.error;
	// Affichage d'un message pour chaque erreur dans la console
	console.error = function () {
		// eslint-disable-next-line prefer-rest-params
		const args = arguments;
		devToolbarStore.addConsoleError(Array.prototype.slice.apply(args).join(' '));
		return _error.apply(console, args as any);
	};
}

ReactDOM.createRoot(document.getElementById('root')!).render(
	// Désactivation de React.StrictMode car cela déclenche plusieurs fois les requêtes
	// ce qui entraine des dysfonctionnements avec les resolvable

	// <React.StrictMode>
	<App /> as ReactNode,
	// </React.StrictMode>,
);
